function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2535"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2534"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2533"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 5938",
  d: "M35.148.001A35.3 35.3 0 0 0 .001 35.443 35.3 35.3 0 0 0 35.443 70.59 35.3 35.3 0 0 0 70.59 35.148 35.3 35.3 0 0 0 35.148.001zM24.976 17.292a4.7 4.7 0 0 1 4.715 4.689 4.7 4.7 0 0 1-4.715 4.689 4.7 4.7 0 0 1-4.714-4.691 4.7 4.7 0 0 1 4.714-4.687zm29.056 11.784c-1.24 5.789-5.854 8.841-7.848 9.943l7.553 13.906h-11.73l-11.2-20.705-4.361 20.705h-9.98l1.943-9.145c1.55-7.307 6.327-11.35 12.4-11.56h8.366a3.932 3.932 0 0 0 3.689-3.008 2.4 2.4 0 0 0-2.4-3.06h-8.252l1.812-8.522h10.961c7.03.005 10.238 5.883 9.046 11.449z",
  fill: "#fff"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2537"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2536"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 5939",
  d: "M35.148.001A35.3 35.3 0 0 0 .001 35.443 35.3 35.3 0 0 0 35.443 70.59 35.3 35.3 0 0 0 70.59 35.148 35.3 35.3 0 0 0 35.148.001zM24.976 17.292a4.7 4.7 0 0 1 4.715 4.689 4.7 4.7 0 0 1-4.715 4.689 4.7 4.7 0 0 1-4.714-4.691 4.7 4.7 0 0 1 4.714-4.687zm29.056 11.784c-1.24 5.789-5.854 8.841-7.848 9.943l7.553 13.906h-11.73l-11.2-20.705-4.361 20.705h-9.98l1.943-9.145c1.55-7.307 6.327-11.35 12.4-11.56h8.366a3.932 3.932 0 0 0 3.689-3.008 2.4 2.4 0 0 0-2.4-3.06h-8.252l1.812-8.522h10.961c7.03.005 10.238 5.883 9.046 11.449z",
  fill: "#fff"
})));

function SvgIRobotLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71 71",
    width: 70.589,
    height: 70.589,
    preserveAspectRatio: "xMaxYMax meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "iRobot Logo",
    style: {
      isolation: "isolate"
    }
  }, _ref2, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2539"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2538",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _ref3))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIRobotLogo);
export default __webpack_public_path__ + "static/media/iRobotLogo.4e079088.svg";
export { ForwardRef as ReactComponent };